(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-guides"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initGuides(scope = document) {
    scope.querySelectorAll('[data-hc-guides]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-hc-guide]')];
      const buttons = [...root.querySelectorAll('[data-hc-guide-filter]')];
      const search = root.querySelector('[data-hc-guide-search]');
      const status = root.querySelector('[data-hc-guide-count]');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const labels = new Map(cards.map(card => [card, normalize(card.textContent)]));
      let category = 'all';
      function update() {
        const query = normalize(search.value);
        let visible = 0;
        cards.forEach(card => { const show = (category === 'all' || card.dataset.category === category) && labels.get(card).includes(query); card.hidden = !show; if (show) visible++; });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hcGuideFilter === category)));
        status.textContent = status.dataset.countTemplate.replace('__COUNT__', visible);
        root.querySelector('[data-hc-guide-empty]').hidden = visible > 0;
      }
      buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.hcGuideFilter; update(); }));
      search.addEventListener('input', update);
      root.querySelector('[data-hc-guide-tools]').hidden = false;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initGuides()); else initGuides();
  document.addEventListener('shopify:section:load', event => initGuides(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-model-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hc-model-gallery')) {
  customElements.define('hc-model-gallery', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hc-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-hc-thumb]')];
      this.index = 0;
      this.dialog = this.querySelector('dialog');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelector('[data-hc-gallery-controls]')?.removeAttribute('hidden');
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-hc-thumb]');
        if (thumb) { event.preventDefault(); this.show(Number(thumb.dataset.hcThumb)); return; }
        if (event.target.closest('[data-hc-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-hc-next]')) this.show(this.index + 1);
        const enlarge = event.target.closest('[data-hc-enlarge]');
        if (enlarge && this.dialog) {
          event.preventDefault();
          this.querySelector('[data-hc-full-photo]').src = enlarge.href;
          this.dialog.showModal();
        }
        if (event.target.closest('[data-hc-close]')) this.dialog.close();
      }, options);
      this.addEventListener('keydown', event => {
        if (this.dialog?.open) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          this.thumbs[this.index]?.focus();
        }
      }, options);
      this.show(0);
    }
    disconnectedCallback() { this.events?.abort(); }
    show(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.thumbs.forEach((thumb, i) => { if (i === this.index) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
      const count = this.querySelector('[data-hc-count]');
      if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
      const previous = this.querySelector('[data-hc-prev]');
      const next = this.querySelector('[data-hc-next]');
      if (previous) previous.disabled = this.index === 0;
      if (next) next.disabled = this.index === this.slides.length - 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-projects-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-hc-projects]').forEach(root => {
      if (root.dataset.hcReady) return;
      root.dataset.hcReady = 'true';
      const filters = root.querySelector('.hc-projects-filters');
      const cards = [...root.querySelectorAll('[data-hc-photo]')];
      const empty = root.querySelector('[data-hc-projects-empty]');
      function select(category) {
        filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.hcCategory === category)));
        let count = 0;
        cards.forEach(card => {card.hidden = category !== 'all' && card.dataset.category !== category;if (!card.hidden) count++;});
        empty.hidden = count > 0;
      }
      filters.hidden = false;
      filters.addEventListener('click',event => {const button = event.target.closest('[data-hc-category]');if(button) select(button.dataset.hcCategory);});
      const dialog = root.querySelector('dialog');
      const large = dialog.querySelector('[data-hc-large-photo]');
      let opener;
      root.querySelectorAll('[data-hc-photo-open]').forEach(link => link.addEventListener('click',event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();opener=link;large.src=link.href;large.alt=link.querySelector('img').alt;
        dialog.querySelector('[data-hc-photo-caption]').textContent=link.closest('figure').querySelector('figcaption').innerText;
        dialog.showModal();
      }));
      dialog.querySelector('[data-hc-photo-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.addEventListener('close',()=>{large.removeAttribute('src');if(opener)opener.focus();});
      root.addEventListener('shopify:block:select',()=>select('all'));
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
